import { jsx as _jsx } from "react/jsx-runtime";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { IconButton, Tooltip } from '@mui/material';
export const SignOut = ({ maintenance, isAuthenticated, signOut }) => {
    return (!maintenance &&
        isAuthenticated && (_jsx(Tooltip, { title: 'Sign out', placement: "bottom", arrow: true, children: _jsx(IconButton, { color: "inherit", onClick: () => signOut(), sx: { ['&:hover']: { backgroundColor: (t) => t.palette.primary.dark } }, children: _jsx(ExitToAppIcon, {}) }) })));
};
